"use client";

import { useEffect, useState } from "react";

export interface HTMLContentV2Props {
  content?: string | null;
  variant?: string;
  messageId?: string;
  className?: string;
}

const PURIFY_OPTIONS = {
  ADD_TAGS: ["iframe"],
  ADD_ATTR: [
    "allow",
    "allowfullscreen",
    "frameborder",
    "scrolling",
    "target",
    "style",
  ],
  ALLOW_DATA_ATTR: false,
};

/**
 * Client-only sanitize. Avoid isomorphic-dompurify/jsdom (breaks Next SSR with ERR_REQUIRE_ESM).
 */
export default function HTMLContentV2({ content, className }: HTMLContentV2Props) {
  const [html, setHtml] = useState("");

  useEffect(() => {
    let cancelled = false;

    if (!content) {
      setHtml("");
      return;
    }

    void import("dompurify").then((mod) => {
      if (cancelled) return;
      const DOMPurify = mod.default;
      setHtml(DOMPurify.sanitize(content, { ...PURIFY_OPTIONS }));
    });

    return () => {
      cancelled = true;
    };
  }, [content]);

  if (!html) return null;

  return (
    <div
      className={["prose prose-sm max-w-none dark:prose-invert", className]
        .filter(Boolean)
        .join(" ")}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
